export const wizardStatusItems = (instance) => {
  return {
    DRAFT: { key: 'Draf', label: instance.$t('fleetTask.status.draft') },
    SCHEDULED: { key: 'Dijadwalkan', label: instance.$t('fleetTask.status.scheduled') },
    STARTED: { key: 'Perjalanan', label: instance.$t('fleetTask.status.started') },
    CANCELED: { key: 'Dibatalkan', label: instance.$t('fleetTask.status.canceled') },
    ENDED: { key: 'Selesai', label: instance.$t('fleetTask.status.ended') },
  }
}

export const wizardStatusItemsVendor = (instance) => {
  return {
    DRAFT: { key: 'Draf', label: instance.$t('fleetTask.status.draft') },
    WAITING_FOR_VENDOR: { key: 'Menunggu Vendor', label: instance.$t('fleetTask.status.waiting') },
    ACCEPTED_BY_VENDOR: { key: 'Diterima Vendor', label: instance.$t('fleetTask.status.accepted') },
    REJECTED_BY_VENDOR: { key: 'Ditolak', label: instance.$t('fleetTask.status.rejected') },
    SCHEDULED: { key: 'Dijadwalkan', label: instance.$t('fleetTask.status.scheduled') },
    STARTED: { key: 'Perjalanan', label: instance.$t('fleetTask.status.started') },
    CANCELED: { key: 'Dibatalkan', label: instance.$t('fleetTask.status.canceled') },
    ENDED: { key: 'Selesai', label: instance.$t('fleetTask.status.ended') },
  }
}

export const wizardStatusItemsMgm = (instance) => {
  return {
    DRAFT: { key: 'Draf', label: instance.$t('fleetTask.status.draft') },
    WAITING_FOR_APPROVAL: { key: 'Menunggu Persetujuan', label: instance.$t('fleetTask.status.waitingForApproval') },
    APPROVED: { key: 'Disetujui', label: instance.$t('fleetTask.status.approved') },
    SCHEDULED: { key: 'Dijadwalkan', label: instance.$t('fleetTask.status.scheduled') },
    STARTED: { key: 'Perjalanan', label: instance.$t('fleetTask.status.started') },
    CANCELED: { key: 'Dibatalkan', label: instance.$t('fleetTask.status.canceled') },
    ENDED: { key: 'Selesai', label: instance.$t('fleetTask.status.ended') },
  }
}
